const initialState = {
  spinner: false,
  loader: false,
  progress: 0
}

export const LoadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOADING': {
      return { ...state, loader: action.payload }
    }
    case 'LOADING_PROGRESS': {
      return { ...state, progress: action.payload }
    }
    default:
      return state
  }
}

export const SpinnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SPINNER': {
      return { ...state, spinner: action.payload }
    }
    default:
      return state
  }
}
